import { useTranslation } from 'react-i18next';

function TabList() {
  const { t } = useTranslation();
  const Array = [];

  const accesingObj: { [val: number]: string } = {
    0: t('biz_process.main_information'),
    1: t('biz_process.standart_activity'),
  };

  const typeTab = (val: number) => accesingObj[val] || '';

  for (let index = 0; index <= 1; index++) {
    const Data = { id: index, name: typeTab(index) };
    Array.push(Data);
  }

  return Array;
}

export default TabList;
